import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'cdss-patient-overview-v2-adherence-stat',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './patient-overview-v2-adherence-stat.component.html',
    styleUrl: './patient-overview-v2-adherence-stat.component.scss'
})
export class PatientOverviewV2AdherenceStatComponent {
    @Input() type = 'patient';
    @Input() chapterAdherence: number | null = null;
    @Input() checkinAdherence: number | null = null;
    @Input() foodDiaryCompletion: number | null = null;
    @Input() disabled = false;

    formatPercent(value: number | null): string {
        if (value == null || Number.isNaN(value)) return '--';
        return `${Math.round(value)}%`;
    }

    /** Filled share of the ring, 0-100; missing or invalid values draw an empty ring. */
    ringPercent(value: number | null): number {
        if (value == null || Number.isNaN(value)) return 0;
        return Math.min(100, Math.max(0, value));
    }
}
